<template>
  <iInput
    v-model="inputValue"
    :icon="icon"
    :clearable="!icon"
    size="small"
    @on-change="onTyping()" />
</template>

<script>
import { debounce } from 'lodash';

export default {
  name: 'InputFilter',
  model: {
    event: 'change',
  },
  props: {
    value: { type: String, default: '' },
  },
  data() {
    return {
      inputValue: '',
      typing: false,
    };
  },
  computed: {
    icon() {
      return this.typing ? 'ios-loop-strong' : '';
    },
    debounedTyping() {
      return debounce(this.onChange, 300);
    },
  },
  watch: {
    value: {
      handler() {
        this.inputValue = this.value;
      },
      immediate: true,
    },
  },
  methods: {
    onTyping() {
      this.typing = true;
      this.debounedTyping();
      if (!this.inputValue) this.debounedTyping.flush();
    },
    onChange() {
      this.typing = false;
      this.$emit('change', this.inputValue || null);
    },
  },
};
</script>

<style scoped>
</style>
